import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

const Backdrop = (theme: Theme) => {
  return {
    MuiBackdrop: {
      styleOverrides: {
        invisible: {
          background: 'transparent',
        },
        root: {
          backgroundColor: alpha(theme.palette.grey[800], 0.8),
        },
      },
    },
  };
};

export default Backdrop;
